export const environment = {
    OCP_APIM_SUBSCRIPTION_KEY_DEV: '7d1e89b7305c4886a418a553a3dbead6',
    OCP_APIM_SUBSCRIPTION_KEY_TEST:'7d1e89b7305c4886a418a553a3dbead6',
     OCP_APIM_SUBSCRIPTION_KEY_PROD: '32cf1ee890cd4f92b7ddaa94e78cda29'
}
